var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"GoogleMapsLink",attrs:{"href":_vm.Address.GoogleMapsWebSiteURL,"target":"_blank"}},[_c('font-awesome-icon',{attrs:{"icon":['fa', 'globe']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }